import * as Sentry from '@sentry/react';
import { ApiError } from '@repo/api-client';

/**
 * Report errors to Sentry with optional context data.
 * Skips expected 4xx client errors (401, 403, 404, 422) unless explicitly forced.
 */
export function reportWebError(error: unknown, context?: Record<string, unknown>): void {
  if (!error) return;

  if (error instanceof ApiError) {
    const status = error.status;
    // Skip routine client errors (401, 403, 404, 422 validation)
    if (status && status >= 400 && status < 500 && status !== 408 && status !== 429) {
      return;
    }

    Sentry.captureException(error, {
      extra: {
        status: error.status,
        code: error.code,
        details: error.details,
        ...context,
      },
    });
    return;
  }

  if (error instanceof Error) {
    Sentry.captureException(error, {
      extra: context,
    });
    return;
  }

  Sentry.captureMessage(typeof error === 'string' ? error : String(error), {
    extra: context,
  });
}
